<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" :fill="color" />
    <path
      d="M7.03125 4H8.96875L8.64583 9.16384H7.35417L7.03125 4ZM8 12C7.71528 12 7.47569 11.9021 7.28125 11.7062C7.09375 11.5028 7 11.258 7 10.9718C7 10.6855 7.09375 10.4482 7.28125 10.2599C7.46875 10.064 7.70833 9.9661 8 9.9661C8.29167 9.9661 8.53125 10.064 8.71875 10.2599C8.90625 10.4482 9 10.6855 9 10.9718C9 11.258 8.90278 11.5028 8.70833 11.7062C8.52083 11.9021 8.28472 12 8 12Z"
      :fill="textColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconExclamation",

  props: {
    // цвет иконки
    color: {
      type: String,
      default: "#FF5B37"
    },
    // цвет восклицательного знака
    textColor: {
      type: String,
      default: "#FFFFFF"
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
